import type { CSSProperties } from 'react';
import { previewNote, resumeAudio } from '../audio/noteSounds';
import type { NoteColors, NoteId } from '../types';
import { NOTE_LABELS } from '../types';

const NOTES: NoteId[] = ['do', 're', 'mi', 'fa', 'sol', 'la', 'si', 'rest'];

interface Props {
  colors: NoteColors;
  selected: NoteId;
  onSelect: (note: NoteId) => void;
  soundEnabled: boolean;
  variant?: 'default' | 'melody';
  layout?: 'horizontal' | 'vertical';
}

function PaintbrushIcon() {
  return (
    <svg className="palette-brush" viewBox="0 0 32 32" aria-hidden="true" width="24" height="24">
      <path
        d="M6 26 L10 22 L22 10 L26 14 L14 26 Z"
        fill="#E53935"
        stroke="#B71C1C"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M22 10 L26 6 L28 8 L24 12 Z" fill="#FFD54F" />
      <rect x="4" y="24" width="8" height="4" rx="1" fill="#5D4037" transform="rotate(-45 8 26)" />
    </svg>
  );
}

export function NotePalette({
  colors,
  selected,
  onSelect,
  soundEnabled,
  variant = 'default',
  layout = 'horizontal',
}: Props) {
  const isMelody = variant === 'melody';
  const isVertical = layout === 'vertical';

  return (
    <div
      className={[
        'note-palette',
        isMelody ? 'note-palette--melody' : '',
        isVertical ? 'note-palette--vertical' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      role="toolbar"
      aria-label="Seleccionar nota"
    >
      {isMelody && selected !== 'rest' && (
        <div className="palette-brush-wrap" aria-hidden="true">
          <PaintbrushIcon />
        </div>
      )}
      {NOTES.map((note) => (
        <button
          key={note}
          type="button"
          className={`palette-btn ${selected === note ? 'palette-btn--selected' : ''}`}
          onClick={async () => {
            onSelect(note);
            if (soundEnabled && note !== 'rest') {
              await resumeAudio();
              previewNote(note);
            }
          }}
          style={{ '--note-color': colors[note] } as CSSProperties}
          aria-pressed={selected === note}
        >
          <span className="palette-btn__swatch" />
          <span className="palette-btn__label">{NOTE_LABELS[note]}</span>
        </button>
      ))}
    </div>
  );
}
